import styled from 'styled-components';

// eslint-disable-next-line import/prefer-default-export
export const Container = styled.div`
  padding: 1rem;
  overflow: auto;

  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE 10+ */
  ::-webkit-scrollbar-track {
    -webkit-box-shadow: none !important;
    background-color: transparent;
  }
  ::-webkit-scrollbar {
    width: 3px !important;
    background-color: transparent;
  }
  ::-webkit-scrollbar-thumb {
    background-color: transparent;
  }


  .table {
    border-spacing: 0;

    .thead {
      ${'' /* These styles are required for a scrollable body to align with the header properly */}
      overflow-y: auto;
      overflow-x: hidden;
    }

    .tbody {
      ${'' /* These styles are required for a scrollable table body */}
      overflow-y: scroll;
      overflow-x: hidden;
      height: 250px;
    }

    .row.tr > .th{
      border-bottom: 1px solid #EBEDF3;
    }
    .row-header.tr {
      background-color: #f8f8ff;
    }

    .th,
    .td {

      ${'' /* In this example we use an absolutely position resizer,
       so this is required. */}
      position: relative;

      .resizer {
        right: 0;
        background: blue;
        width: 10px;
        height: 30%;
        bottom: 0;
        margin: auto;
        position: absolute;
        top: 0;
        z-index: 1;
        ${'' /* prevents from scrolling while dragging on touch devices */}
        touch-action :none;

      }
    }
  }


  & div.table {
    width: 100%;
  }

  & div.table div.th:not(.row-header) {
    padding: 0.75rem;
    font-size: 0.9rem;
    font-weight: 600;
    color: #B5B5C3;

    //text-align: center;
  }


  & div.table div.row.th,
  div.table div.row.tr {
    margin: 0;
    // border-bottom: 1px solid #EBEDF3
  }

  div.table div.row.tr.clickable{
    cursor: pointer;
  }

  & div.table div.td{
    padding: 0.75rem;
  }

  & .ant-btn-primary{
    color: #7E8299;
    background-color: #F3F6F9;
    border-color: #F3F6F9;
  }

  & .ant-btn-primary span{
    color: ${(props) => props.theme.palette.primary.main};
  }

  & .ant-pagination {
    text-align: center;
    margin-top: 30px;
  }

  & .table .th .resizer, .table .td .resizer {
    width: 1px;
    background: #ddd;
  }

  & .table .row:not(.row-header).tr:hover {
    background: rgba(230, 230, 230, 0.3) !important;
  }


  & input:disabled {
    border: none !important;
    background: transparent  !important;
    color: #495057;
  }

}
`;
